import React from 'react'
import { Widget, mk_widget, AsyncState, Pair, mk_pair } from 'widgets-for-react'
import { WordPress } from '../../wordpress/wordpress_api'
import { Map } from 'immutable'
import { NavLink } from 'react-router-dom'
import { Page } from '../../cms/page/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { toRelativeUrl, gtmPush } from '../../../helpers'
import { loader } from './loader.mod'
import { PublicSiteState } from '../../public_site.main.mod'
import { breadcrumb } from '../../../styleguide/components/components/pageHeader'
import { getImageSize } from '../utils/extra_images.mod';

type FaqProps = {
  data: WordPress.PostResponse<any>
}

type FaqState = {
  open: boolean
}

export class DetailItem extends React.Component<FaqProps, FaqState> {
  constructor(props: FaqProps) {
    super(props)

    this.state = {
      open: false
    }

    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    if (!this.state.open) {
      gtmPush({ category: 'FAQ', action: 'open', label: this.props.data.slug })
    }
    this.setState({ open: !this.state.open })
  }

  makeIntro = (text: string, max_words: number) => {
    let intro = text.split(' ').slice(0, max_words).join(' ')
    return intro + (intro.length == text.length ? '' : '...')
  }

  render() {
    const open = this.state.open
    let header: any = this.props.data.custom_blocks.find(b => b.blockName == 'vidda/hero' as any)
    let paragraph = this.props.data.custom_blocks.find(b => b.blockName == 'core/paragraph' || b.blockName == 'vidda/text')
    let faq_text = paragraph ? paragraph.innerHTML : ''
    let faq_image: WordPress.Image = null
    if (header != undefined) {
      faq_text = header.attrs && header.attrs.intro ? header.attrs.intro : ''
      faq_image = header.attrs && header.attrs.image ? header.attrs.image : null
    }
    return (

      <li className="grid__item item">
        <article className="grid__article">
          <NavLink to={toRelativeUrl(this.props.data.link)} className="grid__inner grid__link grid__link--text">
            <div className="grid__content">
              <header className="grid__header">
                <h3 className="grid__title typo--m">{this.props.data.title.rendered}</h3>
                {/** Put a small portion of the text as intro, change the second parameter of slice to set the maximum amount of words */}
                <div className="grid__intro" dangerouslySetInnerHTML={{ __html: this.makeIntro(faq_text, 15) }} />
              </header>
              <svg
              className={`grid__icon grid__icon--text`}
              width="25px"
              height="14px"
              aria-hidden="true"
              >
                <use xlinkHref="#icon--arrow" />
              </svg>
            </div>

            {faq_image && (
            <div className="grid__visual">
              <img
                src={getImageSize(faq_image, '1320x765')}
                data-src={getImageSize(faq_image, '440x255')}
                data-srcset={[
                  [getImageSize(faq_image, '440x255') + ' 440w'],
                  [getImageSize(faq_image, '880x510') + ' 880w'],
                  [getImageSize(faq_image, '1320x765') +' 1320w'],
                ]}
                data-sizes="auto"
                width="440" 
                height="255"
                className="grid__image"
              />
            </div>
          )}

          </NavLink>
        </article>
      </li>
    )
  }
}


function parseCategories(faqs: AsyncState<Array<WordPress.FaqResponse>>): Pair<WordPress.TaxonomyResponse[], Map<number, WordPress.FaqResponse[]>> {
  if (faqs.kind != 'loaded') return mk_pair([], Map())

  let terms_and_faq = faqs.value.reduce((result, faq) => {
    faq['faq-category'] && faq['faq-category'].forEach(term => {

      // Make FAQ Map
      if (result.snd.has(term.term_id)) {
        let current = result.snd.get(term.term_id)!
        result.snd = result.snd.set(term.term_id, current.concat(faq))
      } else {
        result.snd = result.snd.set(term.term_id, [faq])
      }

      // Make Taxonomy list ordered
      result.fst = result.fst.set(term.term_id, term)

    })
    return result
  }, mk_pair<Map<number, WordPress.TaxonomyResponse>, Map<number, WordPress.FaqResponse[]>>(Map(), Map()))

  return ({
    ...terms_and_faq,
    fst: terms_and_faq.fst.toIndexedSeq().sortBy(term => term.term_order).toArray()
  })
}

export const faqOverview: (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  faqs: AsyncState<Array<WordPress.FaqResponse>>,
  state: PublicSiteState
) => Widget<never> = (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  faqs: AsyncState<Array<WordPress.FaqResponse>>,
  state: PublicSiteState
) =>
    mk_widget({
      run: _ => {

        const hero = page.blocks.filter(b => b.kind == "vidda/hero" && b).pop()

        let terms_and_faq = parseCategories(faqs)
        let terms = terms_and_faq.fst
        let faq = terms_and_faq.snd

        return <>

        <header className={`page-header ph ph--faq ph--secondary ph--page`}>
          <div className={`ph__outer container container--l`}>
            <div className="ph__inner">
              <div className="ph__content content">
                <div className="ph__header">
                  <h1 className="ph__title typo--xl">{hero && hero.kind == 'vidda/hero' ? hero.attrs.title : page.extra_data.post.title.rendered}</h1>
                  <div>
                    {hero && hero.kind == 'vidda/hero' ? 
                      <p className="ph__intro" dangerouslySetInnerHTML={{ __html: hero.attrs.intro }} />
                      : 
                      <p className="ph__intro" dangerouslySetInnerHTML={{ __html: page.extra_data.post.title.rendered }} />} </div>
                  </div>
              </div>
            </div>
              {/* Breadcrumbs */}
              {
                state.page.custom_page_data &&
                state.page.custom_page_data.v.kind == 'r' &&
                state.page.custom_page_data.v.v.post.breadcrumb &&
                state.page.custom_page_data.v.v.post.breadcrumb.itemListElement &&
                !state.page.custom_page_data.v.v.post.is_front &&
                  (
                  breadcrumb(state.page.custom_page_data.v.v.post.breadcrumb.itemListElement.map(crumb => crumb.item['@id'] ? ({ title: crumb.item.name, url: crumb.item['@id'] }) : undefined).filter(item => item != undefined))
                  )

              }
          </div>
        </header>

        {faqs.kind == 'loaded' ?
          terms.map((cat) => (<section key={`term-faq-category-${cat.term_id}`} className="block block--faq block--grid block--overview">
            <div className="block__inner container container--l grid--block">
              <header className="block__header">
                <div className="block__header-inner">
                  <h2 className="block__title typo--l">{cat.name}</h2>
                  {cat.description && <div className="block__intro text--styled">{cat.description}</div>}
                </div>
              </header>
              <div className="block__content">
                {faq.has(cat.term_id) && <ul className="block__grid grid c--columns">
                  {faq.get(cat.term_id).map((faq) => {
                    return <DetailItem key={`faq-${faq.slug}`} data={faq} />
                  })}
                </ul>}
              </div>

            </div>
          </section>)
          )
          :
          loader.run(_ => { })
        }
        </>
      }
    })



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/faq_overview.tsx